// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth"
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCpLXP9OaGgaJ88If2VnJxYF75dSqSUSuY",
  authDomain: "oogwai-analytics-20244.firebaseapp.com",
  projectId: "oogwai-analytics-20244",
  storageBucket: "oogwai-analytics-20244.firebasestorage.app",
  messagingSenderId: "737923130735",
  appId: "1:737923130735:web:99718306c32f1295a4749a",
  measurementId: "G-P6508PSDBR"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, provider, db, storage };